<form nz-form [formGroup]="_fS.addVendorForm" class="vendor-form-box pb-50" cdkScrollable>
    <div class="est">
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!isEditVendor" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="companyNameError">
                        <label class="label-text required">Company name</label>
                        <input class="input-group" nz-input formControlName="companyName" minlength="2" maxlength="100"
                            placeholder="Enter company name" />
                        <ng-template #companyNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter company name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Company name must contain at least 2
                                characters
                            </ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter company name
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" *ngIf="!isEditVendor">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="emailAddressError">
                        <label class="label-text">Email address</label>
                        <input class="input-group" nz-input formControlName="emailAddress"
                            placeholder="Enter email address"
                            pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}" />
                        <ng-template #emailAddressError let-control>
                            <ng-container *ngIf="control.hasError('pattern')">Enter valid email address
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="mb-1">
            <div class="right">
                <span class="mr-1 fs-14">Domestic</span>
                <nz-switch [(ngModel)]="isaddLinesClicked" (ngModelChange)="addLinesClicked($event)"
                    [ngModelOptions]="{standalone: true}" nzSize="small"></nz-switch>
                <span class="ml-1 fs-14">International</span>
            </div>
        </div>

        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">
            <div *ngIf="!isaddLinesClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="address1Error">
                        <label class="label-text required">Address 1</label>
                        <input class="input-group" nz-input formControlName="streetAddress1" minlength="2"
                            maxlength="100" placeholder="Enter address 1">
                        <ng-template #address1Error let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter street address
                                1</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Street address must contain at least 2
                                characters
                            </ng-container>
                        </ng-template>
                        <!-- <span *ngIf="!isaddLinesClicked" (click)="addLinesClicked()" class="cursor fs-14"><span nz-icon
                                nzType="down" class="pr-12 fs-12" nzTheme="outline"></span>International</span> -->
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div *ngIf="!isaddLinesClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="address2Error">
                        <label class="label-text">Address 2</label>
                        <input class="input-group" nz-input formControlName="streetAddress2" minlength="2"
                            maxlength="100" placeholder="Enter address 2" />
                        <ng-template #address2Error let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter street address
                                2</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Street address must contain at least 2
                                characters
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div *ngIf="isaddLinesClicked" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="address1Error">
                        <label class="label-text required">International address</label>
                        <textarea class="input-group" nz-input rows="4" formControlName="internationalAddress" minlength="2"
                            maxlength="255" placeholder="Enter International address"></textarea>
                        <!-- <span (click)="addLinesClicked()" class="cursor"><span nz-icon nzType="down" class="pr-12 fs-12"
                                nzTheme="outline"></span>US Address</span> -->
                        <ng-template #address1Error let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter international address
                            </ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">International address must contain at
                                least 2
                                characters
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>



            <div *ngIf="!isaddLinesClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="cityError">
                        <label class="label-text required">City / Town</label>
                        <input class="input-group" nz-input formControlName="city" minlength="2" maxlength="100"
                            (keypress)="_cS.checkAlphabetsWithSpace($event)" placeholder="Enter city" />
                        <ng-template #cityError let-control>
                            <ng-container *ngIf="control.hasError('minlength')">City must contain atleast 2
                                characters</ng-container>
                            <ng-container *ngIf="control.hasError('required')">Please select city</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div *ngIf="!isaddLinesClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="StateError">
                        <label class="label-text required">State</label>
                        <nz-select nzShowSearch nzPlaceHolder="Select state" [nzSize]="'default'"
                            formControlName="state" [nzSelectOnTab]="true" (ngModelChange)="focusZipCode($event)">
                            <nz-option *ngFor="let state of listOfStates" [nzLabel]="state"
                                [nzValue]="state"></nz-option>
                        </nz-select>
                        <ng-template #StateError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please select state</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div *ngIf="!isaddLinesClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="zipCodeError">
                        <label class="label-text required">Zip code</label>
                        <input #zipCode autocomplete="off" class="input-group" (keypress)="_cS.checkNumbers($event)"
                            minlength="5" nz-input formControlName="zipCode" name="zipCode" maxlength="12"
                            mask="00000||00000-0000" placeholder="Enter zip code" />
                        <ng-template #zipCodeError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter zipcode</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Zip code must contain at least 5
                                digits
                            </ng-container>
                            <ng-container
                                *ngIf="_fS.addVendorForm.get('zipCode').value?.length > 5 && _fS.addVendorForm.get('zipCode').value?.length < 9">Please
                                enter valid zipcode (XXXXX-XXXX or XXXXX)
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div *ngIf="!isaddLinesClicked" nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="countryError">
                        <label class="label-text required">Country</label>
                        <input value="USA" formControlName="country" nz-input>
                        <ng-template #countryError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter country</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <!-- [ngClass]="isAddAddressClicked ? '' :'pt-20'" -->
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0">
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="phoneError">
                        <label class="label-text">Phone number</label>
                        <input class="input-group" nz-input formControlName="phoneNumber"
                            (keypress)="_cS.checkNumbers($event)" mask="(000) 000-0000" pattern="\d{10}"
                            placeholder="Enter phone number">
                        <ng-template #phoneError let-control>
                            <ng-container *ngIf="control.hasError('pattern')">
                                Mobile number must contain at least 10 digits
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                    <nz-form-control>
                        <label class="label-text">Upload W9 form</label>
                        <nz-upload nzType="drag" nzAccept=".pdf" [nzMultiple]="false"
                            (nzChange)="handleChangeUpload($event)" [nzBeforeUpload]="beforeUpload"
                            [nzFileListRender]="fileListTpl" nzAction="https://file.io/">
                            <div class="d-flex"><span nz-icon nzType="inbox" class="inbxoIcon"></span>
                                <p class="ant-upload-text">Click or drag file to this area to upload</p>
                            </div>
                            <ng-template #fileListTpl let-list>
                                <ng-container *ngIf="uploadedFile && uploadedFile.name">
                                    <p class="item-name-text"><span (click)="openDocView()"
                                            [ngClass]="currentVendorData && currentVendorData.w9AttachmentURL && currentVendorData.w9AttachmentName == uploadedFile.name  ? 'showHyperLink cursor' : ''">{{
                                            uploadedFile?.name }}</span><a><img (click)="deleteFile()"
                                                src="/assets/images/delete.png " class="cursor"></a>
                                    </p>
                                </ng-container>
                            </ng-template>
                        </nz-upload>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </div>
</form>

<div class="d-flex justify-content-end footer-box vendor-form-footer">
    <button nz-button nzType="default" (click)="handleCancel(null)" class="default-btn width-100 mr-1">Cancel</button>
    <button nz-button nzType="primary" [nzLoading]="isAddingVendor" (click)="checkUploadedFile()"
        class="medium-btn small-btn width-100 mr-0 ">{{isEditVendor ? 'Update' : 'Create'}}</button>
</div>


<!--confirmation modal for non-alc over balance-->
<nz-modal [nzVisible]="ShowConfirmDialog" (nzOnCancel)="ShowConfirmDialog = false" (nzOnOk)="handleOk()" nzCentered
    [nzTitle]="'Missing Vendor W-9 Form'" [nzWidth]="850" [nzMaskClosable]="false" [nzFooter]="footerTpl"
    [nzZIndex]="1000">
    <div *nzModalContent>
        <p class="investment-company-name center">You have not uploaded W-9 forms for this new vendor. Payment may be
            delayed if you proceed. Note: Credit card payments do not require a W-9.</p>
        <p class="investment-company-name center">W-9 form can be sent to <a
                href="mailto:ap@paybev.com">{{'ap@paybev.com'}}</a></p>
    </div>
    <ng-template #footerTpl>
        <button nz-button nzType="default" class="default-btn width-100" (click)="ShowConfirmDialog = false">
            <span>Back</span>
        </button>
        <button nz-button nzType="primary" class="medium-btn width-100"
            (click)="this.isEditVendor ? this.updateVendorDetails() : this.handleOk()" [nzLoading]="isAddingVendor">
            <span>Continue</span>
        </button>
    </ng-template>
</nz-modal>